"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCreatorSelector = void 0;
const userRoleSelector_1 = __importDefault(require("root/src/client/logic/auth/selectors/userRoleSelector"));
const auth_1 = require("root/src/shared/constants/auth");
const isCreatorSelector = (state) => {
    return (0, userRoleSelector_1.default)(state) === auth_1.userGroups.creator;
};
exports.isCreatorSelector = isCreatorSelector;
